import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
// components
import SkillBlock from './SkillBlock';

const SkillsList = ({ userSkills }) => {
  return userSkills.map((skill, index) => (
    <SkillBlock key={index} skill={skill} />
  ));
};

SkillsList.propTypes = {
  skills: T.arrayOf(
    T.shape({
      id: T.oneOfType([T.string, T.number]),
      title: T.string
    })
  )
};

export default connect(
  state => ({
    userSkills: state.skills.userSkills
  }),
  null
)(SkillsList);



// WEBPACK FOOTER //
// ./src/containers/Skills/components/SkillsList.jsx